// useIntakeStore.ts
import { create } from 'zustand';
import { Label } from 'web/model/Label';

interface IntakeStore  {
    isIntakeRecording: boolean;
    consentGiven: boolean;
    label: Label | null;
    cancelAdd: () => void;
    resetIntakeState: () => void;
    setRecording: (isIntakeRecording: boolean) => void;
    setIntakeDetails: (label: Label | null, cancelAdd: () => void) => void;
}

export const useIntakeStore = create<IntakeStore>((set) => ({
    isIntakeRecording: false,
    consentGiven: false,
    label: null,
    cancelAdd: () => console.log("Addition cancelled"),
    resetIntakeState: () => set({ isIntakeRecording: false, consentGiven: false, label: null, cancelAdd: () => console.log("Addition cancelled") }),
    setIntakeDetails: (label: Label | null, cancelAdd: () => void) => set({ consentGiven: true, label, cancelAdd }),
    setRecording: (isIntakeRecording: boolean) => set({ isIntakeRecording }),
}));
